import { createContext } from 'react';

import type { AppSettings } from './../appSettings';
import { getAppSettings } from './../appSettings';

export const AppSettingsContext = createContext<AppSettings | undefined>(undefined);

export const AppSettingsContextProvider: React.FC<{ children?: React.ReactNode }> = ({
  children,
}) => {
  return (
    <AppSettingsContext.Provider value={getAppSettings()}>{children}</AppSettingsContext.Provider>
  );
};
